import { css } from '@emotion/react';
import { Grid, Typography } from '@material-ui/core';
import { i18n } from 'lib/i18n';
import { useColors } from 'hooks/useColors';
import { IColors } from 'types/colors';
import { mobileOnly } from 'styles/utils';

const layoutcss = css`
	margin-top: 30px;
	${mobileOnly} {
		margin-top: 90px;
	}
	margin-bottom: 30px;
`;

const spacingcss = css`
	&.MuiGrid-item {
		${mobileOnly} {
			margin-top: 6px;
		}
	}
`;

const primaryCss = (colors: IColors) => css`
	&.MuiTypography-root {
		color: ${colors.tx_text_secondary};
		font-size: 1.4rem;
		line-height: 1.2;
	}
`;

const secondaryCss = (colors: IColors) => css`
	&.MuiTypography-root {
		color: ${colors.tx_text_primary};
		font-size: 1.6rem;
		font-weight: 600;
		line-height: 1.2;
		${mobileOnly} {
			margin-bottom: 10px;
		}
	}
`;

interface EventProps {
	memberName: string;
	signedDate: string;
}

function Details({ memberName, signedDate }: EventProps) {
	const { colors } = useColors();
	return (
		<Grid container css={layoutcss}>
			<Grid item md={3} xs={12}>
				<Typography css={primaryCss(colors)}>{i18n.waiver.confirmation.memberName}</Typography>
				<Typography css={secondaryCss(colors)}>{memberName}</Typography>
			</Grid>
			<Grid item md={4} xs={12} css={spacingcss}>
				<Typography css={primaryCss(colors)}>
					{i18n.waiver.confirmation.WaiverDate}
					<Typography css={secondaryCss(colors)}>{signedDate}</Typography>
				</Typography>
			</Grid>
		</Grid>
	);
}

export default Details;
